const initRetailLabel = () => {
  const baseUrl = 'https://dhwebservice.co.uk/api/v1/hortihouse';
  const testUrl = 'https://test.dhwebservice.co.uk/api/v1/hortihouse';
  const overrideForm = document.querySelector("[data-retail-admin]"),
    overrideButton = document.querySelector("[data-retail-admin-button]"),
    addressUpdaters = document.querySelector('[data-retail-addresses'),
    addressTemplate = document.querySelector("[data-retail-address-template]");

  const performFetch = async (method = 'GET', endpoint, data, responseType = 'json') => {
    let url = `${baseUrl}${endpoint}`;
    const fetchParams = {
      mode: 'cors',
      method,
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': 'TkplU01VLUs1UUZkaTNLZXpiTE10QzVZclVnRzdRdU1hckl6T2NjYzZKS1Vua0Iw',
      },
    };
    if (data) {
      if (method === 'POST') fetchParams.body = JSON.stringify(data);
      else url += `?${new URLSearchParams(data).toString()}`;
    }

    const response = await fetch(url, fetchParams);
    return responseType === 'json' ? await response.json() : await response.text();
  };

  const attachUserSelector = () => {
    if (!overrideForm || !overrideButton) return;
    const originalText = overrideButton.textContent;

    if(sessionStorage.getItem("retailLabelCustomer")) {
      window.retailLabelCustomer = JSON.parse(sessionStorage.getItem("retailLabelCustomer"));
    }

    overrideForm.email.value = window.retailLabelCustomer.email;

    overrideForm.addEventListener("submit", async (event) => {
      event.preventDefault();
      overrideForm.email.disabled = true;
      overrideForm.email.readonly = true;
      overrideButton.disabled = true;
      overrideButton.innerText = "Logging in...";

      const { data, errors } = await performFetch(
        "GET",
        "/find-customer",
        { email: overrideForm.email.value },
        "json"
      );
      const id = data?.id ?? null;

      if (errors.length || !id) {
        alert("Unable to login, check email & try again");
        overrideForm.email.disabled = false;
        overrideForm.email.readonly = false;
        overrideButton.disabled = false;
        overrideButton.textContent = originalText;
        return;
      }

      window.retailLabelCustomer = {
        id: id,
        email: overrideForm.email.value,
      };
      sessionStorage.setItem("retailLabelCustomer", JSON.stringify(window.retailLabelCustomer));

      overrideButton.textContent = "Refreshing data...";
      await attachAddressUpdaters();
      overrideForm.email.disabled = false;
      overrideForm.email.readonly = false;
      overrideButton.disabled = false;
      overrideButton.textContent = originalText;
    });
  };

  const attachAddressUpdaters = async () => {
    if (!addressUpdaters) return;

    addressUpdaters.innerHTML = '';

    const { data, errors } = await performFetch('GET', '/customer-notification-data', { customerId: window.retailLabelCustomer.id }, 'json');

    if (errors.length) {
      alert('Could not fetch address details, reload the page and try again');
      return;
    }

    data.forEach(
      ({
        companyName,
        addressLine1,
        addressLine2,
        city,
        country,
        deliveryContact,
        deliveryPhone,
        invoiceContact,
        invoicePhone,
        salesContact,
        salesPhone,
        postcode,
      }) => {
        const updater = addressTemplate.content.firstElementChild.cloneNode(true);
        const updaterForm = updater.querySelector('form'),
          updaterButton = updater.querySelector('[data-retail-address-form-button]'),
          updaterLog = updater.querySelector('[data-retail-address-form-status]');
        
        const addressSummary = [addressLine1, addressLine2, city, country, postcode]
          .filter((part) => part?.length)
          .join(',<br />');

        addressUpdaters.appendChild(updater);

        updater.querySelector('[data-retail-address-zip]').innerText = companyName.length ? companyName : postcode;
        updater.querySelector('[data-retail-address-summary]').innerHTML = addressSummary;

        updaterForm.salesContact.value = salesContact;
        updaterForm.salesPhone.value = salesPhone;
        updaterForm.deliveryContact.value = deliveryContact;
        updaterForm.deliveryPhone.value = deliveryPhone;
        updaterForm.invoiceContact.value = invoiceContact;
        updaterForm.invoicePhone.value = invoicePhone;

        updaterForm.addEventListener('submit', async (event) => {
          event.preventDefault();
          updaterButton.disabled = true;

          const formData = Object.fromEntries(new FormData(updaterForm));
          const data = {
            customerId: window.retailLabelCustomer.id,
            postcode,
            ...formData,
          };

          updaterLog.style.removeProperty('display');
          updaterLog.innerText = 'Requesting update...';

          const { status, errors } = await performFetch('POST', '/customer-notification-data', data, 'json');
          updaterButton.disabled = false;

          if (errors.length) {
            updaterLog.textContent = `Error: ${errors.join(', ')}`;
          } else {
            updaterLog.textContent = 'Done';
          }
        });
      }
    );
  };

  attachUserSelector();
  attachAddressUpdaters();
};

initRetailLabel();